import { object, string, number, array ,date, InferType } from 'yup';

const QuickAddScheme = object({
    name: string().required(),
    brand: string(),
    category: string(),
    description: string()
})

export default QuickAddScheme